module.exports = __webpack_public_path__ + "static/media/DSC00534-31_Small.3ac9ee9a.jpg";